export default __webpack_public_path__ + "static/media/Clients.3f66f5c1.png";